// React
import React, { useEffect } from 'react';
import {
  Router,
  Route,
  Switch,
  Redirect,
  MemoryRouter,
} from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';

// App
import AppBar from './appBar';
import Login from './login';
import StripePayment from './payment/stripePayment';
import { isLoggedIn } from '../store/actions/user.action';
import LayoutBuffer from './shared/buffer';
import Notification from './notification';
import ChronJob from './chronJob';
import AppError from './error';
import useCheckCookie from './shared/useCheckCookie';

const App = () => {
  const email = useSelector((state) => state.user?.isAuth);
  const testStatus = useSelector(({ app }) => app.status.tests);
  const dispatch = useDispatch();
  useCheckCookie();

  // Check to see if user's token is still valid
  useEffect(() => {
    dispatch(isLoggedIn());
  }, []);

  // Informs splash screen that React is ready and has rendered.
  useEffect(() => {
    if ((email !== null, testStatus.status !== '')) {
      document.body.classList.add('ready');
    }
  }, [email, testStatus.status]);

  return (
    <MemoryRouter
      onUpdate={() => window.scrollTo(0, 0)}
      initialIndex={1}
      initialEntries={['/payments/error', '/payments/login', '/payments']}
    >
      <Switch>
        {testStatus.error && (
          <Route path="/payments/error">
            <>
              <AppBar />
              <LayoutBuffer>
                <AppError />
              </LayoutBuffer>
            </>
          </Route>
        )}

        <Route path="/payments/login">
          {testStatus.error ? (
            <Redirect to="/payments/error" />
          ) : email ? (
            <Redirect to="/payments" />
          ) : (
            <Login />
          )}
        </Route>

        <Route path="/payments">
          {testStatus.error ? (
            <Redirect to="/payments/error" />
          ) : email ? (
            <>
              <AppBar />
              <LayoutBuffer>
                <StripePayment />
              </LayoutBuffer>
              <Notification />
              <ChronJob />
            </>
          ) : (
            <Redirect to="/payments/login" />
          )}
        </Route>
      </Switch>
    </MemoryRouter>
  );
};

export default App;
